import { Control } from 'react-hook-form'
import { CustomCheckboxInput, QuestionCard, SimpleText, YStack } from '@my/ui'

import { DropdownField, InputField } from '../helpers/Helper'
import images from '../../../assets/images'
import {
  April2026UpdatedOptions,
  climateImpactOptions,
  financialAdviceOptions,
  investmentAmountOptions,
  investmentLengthOptions,
  riskToleranceOptions,
} from '../data'
import { color } from '@my/util'

interface AdditionalInformationProps {
  control: Control<any>
}
export const AdditionalInformation: React.FC<AdditionalInformationProps> = ({ control }) => {
  return (
    <>
      
      <QuestionCard questionGroupTitle="Do you currently work with any of the following? (Select all that apply)">
        <CustomCheckboxInput
          control={control}
          name="Additional Information - Has Other Professional Relationships"
          options={April2026UpdatedOptions['Additional Information'].professionalRelationships}
          multiple
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="Is there anything else about your financial situation you’d like us to know?">
        <InputField
          control={control}
          name="Additional Information - Anything else desired to be shared"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
    </>
  )
}
